export const examresult_index = ['examresult.index']
export const examresult_create = ['examresult.create']
export const examresult_edit = ['examresult.edit']

export default [].concat(
    examresult_index,
    examresult_create,
    examresult_edit
)
